import { Component, OnInit } from '@angular/core';
import { ValidatorFn, FormGroup, ValidationErrors, FormControl, Validators } from '@angular/forms';
import { NeproseService } from 'src/app/services/neprose.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';

export const passwordMatchValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
  const password1 = control.get('newPassword1');
  const password2 = control.get('newPassword2');

  return password1 && password2 && password1.value != password2.value ? { 'passwordMatch': true } : null
}


@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  passwordGroup: FormGroup

  constructor( private authService: AuthService, private _notification: MatSnackBar ) { }

  ngOnInit(): void {

    this.passwordGroup  = new FormGroup({
      'oldPassword': new FormControl('', [Validators.required, Validators.minLength(8)]),
      'newPassword1': new FormControl('', [Validators.required, Validators.minLength(8)]),
      'newPassword2': new FormControl('', [Validators.required]),
    }, { validators: passwordMatchValidator })

  }

  onFormSubmit(form){  
    this.authService.changePassword(form.newPassword1, form.oldPassword).subscribe(data => {
      if(data.status){
        Object.keys(this.passwordGroup.controls).forEach(key => {
          this.passwordGroup.get(key).setErrors(null) ;
        });
        this.openNotification('Password has been changed!')
      }
    }, error => {
      if(error.error){
        this.openNotification(error.error.message)
      }
    })
  } 

  openNotification(msg){
    this._notification.open(msg, 'Cancel', {
      duration: 2000,
      horizontalPosition: 'right'
    })
  }


}
